import PieChartWidget from './PieChartWidget';

export default PieChartWidget; 